export const getPageNotifications = (state) => state.notificationManager.pageNotifications;

export const getPermanentPageNotifications = (state) =>
    state.notificationManager.permanentPageNotifications;

export const getWebsocketError = (state) => state.notificationManager.hasWebsocketError;
